module.exports = __webpack_public_path__ + "img/advantage6.1f5ef94a.png";